import ContactsBanner from './images/ContactsBanner.jpg';
import './App.css';
import { Col, Row, Button, Typography} from 'antd';
import {NavLink} from "react-router-dom";
import Header from "./Header";

const { Title, Text } = Typography;

function Contacts() {
  return (
    <>
        <Header />
        <Row style={{
                minHeight: 220,
                maxWidth: 1024,
                margin: '72px auto'
            }}>
            <Col span={12} style={{ padding: "148px 0" }}>
            
                <Title level={1}>We're here to help, <br />24/7</Title>
                <Title level={5} style={{ paddingRight: 48 }}>Whether you want to browse our Help Centre for solutions or chat with us directly, we’ve got you.</Title>
                <br />
                <br />
                <NavLink className={"menu"} target={'_blank'} to={'https://rekvizitai.vz.lt/imone/amber_information_technologies/'}>
                    <Button size='large' color="default" variant="solid">
                        Contacts
                    </Button>
                </NavLink>
            </Col>

            <Col span={12}>
                <div style={{
                    borderRadius: 24,
                    backgroundImage: `url(${ContactsBanner})`,
                    backgroundPosition: 'right',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    height: "600px",
                    position: "relative",
                }}>
                </div>
            </Col>
        </Row>
    </>
  );
}

export default Contacts;